import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AppScreenBase } from '@app/custom-shared/util/app-screen-base';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MasterClienteHomeCreateProfileComponent } from './master-cliente-create-profile/master-cliente-home-create-profile.component';
import { Permission } from './master-cliente-perfil-acesso.model';
import { MasterClientePerfilAcessoService } from "./services/master-cliente-perfil-acesso.service";

@Component({
  selector: 'app-master-cliente-perfil-acesso',
  templateUrl: './master-cliente-perfil-acesso.component.html',
  styleUrls: ['./master-cliente-perfil-acesso.component.scss']
})

export class MasterClientePerfilAcessoComponent extends AppScreenBase implements OnInit {
  panelOpenState: any;
  profiles: any;
  filterAutoComplete: any;
  userFilter: any;
  clientStatus = true;
  dataAccordion: object;
  name: any;
  sortedData: any;
  permissionDados: Permissions[];
  isAsc = true;
  count: any;
  model: any[];
  indexChoice: number = 0;
  perfilSelected: string;
  dialogConfig: MatDialogConfig;
  clientList: any[];
  lastProfileCreatedId: string;
  movementPermissions:any
  positionPermissions:any
  otherReportPermissions:any
  @Output() filterProfile: EventEmitter<any> = new EventEmitter<any>();
  @Output() onProfileCreated: EventEmitter<any> = new EventEmitter<any>();
  @Input() form: FormGroup;
  @Input() clientIds: BehaviorSubject<string>;
  clientIdsSubscrion: Subscription;
  hasReportsPermission:boolean = false;

  constructor(private perfilAcessoService: MasterClientePerfilAcessoService, private matDialog: MatDialog) { super(); }

  protected onClose(): void { }

  async ngOnInit() {
    this.isSnackbarDismissible = false;

    this.model = await this.perfilAcessoService.getProfiles();
    let radioGroup = this.form.get('profileId');
    if (this.model && this.model.length > 0) {
      radioGroup.setValue(radioGroup.value || this.model[0].id);
    }
    this.model.forEach(profileTypes => {
      let permissionGroups = profileTypes?.permissionGroups
      if (permissionGroups && permissionGroups.length > 0) {
        permissionGroups.forEach(permissionGroup => {
          if (permissionGroup.name == 'Relatorios') {
            this.movementPermissions = permissionGroup.permissions.filter(p =>
              p.name?.startsWith('MOVEMENT')
            )
            this.positionPermissions = permissionGroup.permissions.filter(p =>
              p.name?.startsWith('POSICAO') || p.name?.startsWith('POSITION')
            )
            this.otherReportPermissions = permissionGroup.permissions.filter(
              p => p.name?.startsWith('OTHER')
            )
          }
          if (permissionGroup.name == 'Permissões de relatório') {
            this.hasReportsPermission = permissionGroup.permissions.some(
              permission =>
                permission.name === 'Relatórios' && permission.checked === true
            )
          }
        })

        const desiredOrder = [
          'Permissões de sistema',
          'Permissões de operação',
          'Permissões de relatório',
          'Relatorios',
        ]
        if (permissionGroups) {
          permissionGroups.sort((a, b) => {
            const indexA = desiredOrder.indexOf(a.name)
            const indexB = desiredOrder.indexOf(b.name)
            return indexA - indexB
          })
        }
      }
    })
    this.updateProfileFormValue();
  }
  hasReportsPermissionForSelectedProfile(): boolean {
    if (!this.model || this.model.length === 0) return false;
    
    const selectedProfile = this.model[this.indexChoice];
    if (!selectedProfile?.permissionGroups) return false;
    
    const reportsPermissionGroup = selectedProfile.permissionGroups.find(
      group => group.name === 'Permissões de relatório'
    );
    
    if (!reportsPermissionGroup) return false;
    
    return reportsPermissionGroup.permissions.some(
      permission => permission.name === 'Relatórios' && permission.checked === true
    );
  }
  updateRadioProfile(i) {
    this.indexChoice = i;
    this.updatePermissionGroupsForSelectedProfile();

  }
  updatePermissionGroupsForSelectedProfile() {
    if (!this.model || this.model.length === 0) return;
    
    const selectedProfile = this.model[this.indexChoice];
    if (!selectedProfile?.permissionGroups) return;
    
    selectedProfile.permissionGroups.forEach(permissionGroup => {
      if (permissionGroup.name === 'Relatorios') {
        this.movementPermissions = permissionGroup.permissions.filter(p => p.name?.startsWith('MOVEMENT'));
        this.positionPermissions = permissionGroup.permissions.filter(p => p.name?.startsWith('POSICAO') || p.name?.startsWith('POSITION'));
        this.otherReportPermissions = permissionGroup.permissions.filter(p => p.name?.startsWith('OTHER'));
      }
    });
  }
  async filterUsers(event: Event) {
    this.userFilter = (event.target as HTMLInputElement).value;

    if (this.userFilter.length > 0 && this.userFilter.length % 2 == 0) {
      await this.perfilAcessoService.getProfileSearch(this.userFilter);
      this.proxyAutoComplete(this.userFilter);
    } else if (this.userFilter.length == 0) {
      this.filterAutoComplete = []
    }
  }

  proxyAutoComplete(term = null) {
    if (!term) return;
    const complete = this.profiles.map((client) => {
      return client.permissionGroupProfiles.filter((prof) => {
        return prof.profile != undefined
      }).map((pro) => {
        return pro.profile
      })
    })
    this.filterAutoComplete = [].concat(...complete).filter((ele) => ele.toLowerCase().includes(term.toLowerCase()))
  }

  getSelectedPermissionsLength(permissions: Permission[] = []) {
    return permissions.filter((item) => item.checked == true).length;
  }

  abrirTelaCriarPerfil() {

    this.dialogConfig = new MatDialogConfig();

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.height = '90vh';
    this.dialogConfig.width = '92vw';
    this.dialogConfig.maxWidth = '100vw';

    this.dialogConfig.data = { from: "MasterClientePerfilAcesso" };

    this.matDialog.open(MasterClienteHomeCreateProfileComponent, this.dialogConfig).afterClosed().subscribe(async (result) => {
      if (result) {
        this.appDialog.dismissSnackbar();

        this.lastProfileCreatedId = result;
        this.onProfileCreated.emit(this.lastProfileCreatedId);

        this.model = await this.perfilAcessoService.getProfiles();
        let radioGroup = this.form.get('profileId');

        if (this.model && this.model.length > 0) {

          let index = this.model.findIndex((item, i) => {
            return item.id == this.lastProfileCreatedId;
          });

          if (!index || index < 0) index = 0;
          radioGroup.setValue(this.model[index].id);
          this.updateRadioProfile(index);

          this.updateProfileFormValue();
        }
      }
      this.dialogConfig.data = null;
    });
  }

  updateProfileFormValue() {
    if (this.model && this.model.length > 0) {

      let index = this.model.findIndex((item, i) => {
        return item.id == this.form.get('profileId').value;
      });

      if (!index || index < 0) index = 0;
      const profileFormControl = this.form.get('profile');
      if (profileFormControl) {
        profileFormControl.setValue(this.model[index]);
        this.indexChoice = index;
      }
    }
  }
  getLength(arr: Array<any>) {
    if (arr !== null && arr !== undefined) {
      return arr.length;
    }
    return 0;
  }
}